import { FuseLoadable } from '@fuse';

export const scheduling = { routes: [{ path: '/user-groups', component: FuseLoadable({ loader: () => import('./UserGroupsApp') }) }] };

export default [scheduling];
